<template>
  <div class="notfound">
    <div class="content">
      <img src="https://static.weibangong.com/files/5da95eb0643273b5eccf89d5-big" alt="">
      <h1 class="text-xxl text-black">哎呀，页面丢失了，换个网页试试吧~</h1>
      <p class="text-l">Sorry，page not found！</p>
      <div class="link">
        <router-link to="/" replace class="text-m text-white">返回</router-link>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Notfound',
  data: function(){
    return{
      
    }
  },
  mounted() {
    
  },
  computed: {
    
  },
}
</script>
<style lang="scss" scoped>
    .notfound{
      padding-top: 80px;
      .content{
        text-align: center;
        img{
          width: 486px;
        }
        h1{
          font-weight: 500;
          margin-top: 28px;
        }
        p{
          color: #999999;
          margin-top: 12px;
          font-weight: 400;
          letter-spacing: 1px;
          font-family: "PingFang SC";
        }
        .link{
          margin-top: 52px;
          a{
            display: inline-block;
            width:94px;
            line-height:32px;
            background:rgba(30,136,245,1);
            border-radius:4px;
            &:hover{
              text-decoration: none;
            }
          }
        }
      }
    }
</style>